import { fetchExpenseFeeModalCatalogs } from '@/composables/expensesFees/shared/useExpenseFeeModalCatalogsShared';

export const fetchExpenseModalCatalogs = async () => {
  return fetchExpenseFeeModalCatalogs({
    includeCollaborators: false,
    resolveSalesCompanyIds: true,
  });
};
